import React, { useState } from "react";
import "./HomePage.css";

export default function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  return (
    <div className="homePageContainer">
      <div className="left-content">
        <h2 className="slide-item item-1">darnycya.</h2>
        <h1 className="slide-item item-2">senior software engineer</h1>
        <p className="slide-item item-3">bridging design & backend logic</p>
      </div>

      <div className="rightContent">
        {/* Hamburger icon */}
        <div className="hamburger" onClick={toggleMenu}>
          <span className={`bar ${isMenuOpen ? "open" : ""}`}></span>
          <span className={`bar ${isMenuOpen ? "open" : ""}`}></span>
          <span className={`bar ${isMenuOpen ? "open" : ""}`}></span>
        </div>

        {/* Desktop or expanded mobile menu */}
        <ul className={`nav-link-container ${isMenuOpen ? "active" : ""}`}>
          <li className="slide-item-nav item-nav-1 nav-li">
            <a href="#about" className="nav-links">
              <sup>1</sup>journey
            </a>
          </li>
          <li className="slide-item-nav item-nav-2 nav-li">
            <a href="#clients" className="nav-links">
              <sup>2</sup>clients
            </a>
          </li>
          <li className="slide-item-nav item-nav-2 nav-li">
            <a href="#projects" className="nav-links">
              <sup>3</sup>experiments
            </a>
          </li>
          <li className="slide-item-nav item-nav-3 nav-li">
            <a href="#blogs" className="nav-links">
              <sup>4</sup>reflections
            </a>
          </li>
          <li className="slide-item-nav item-nav-4 nav-li">
            <a href="#contact" className="nav-links">
              <sup>5</sup>start the dialogue
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
